import Image from "../components/form-components/Image";
import logo from "../assets/images/DocoMatic_beta.svg";

const MobileRestricationComponent = () => {
  return (
    <>
      <div className="coming-soon-div d-flex align-items-center justify-content-center">
        <div className="doco_logo">
          <span><Image src={logo} alt="" /></span>
          <h4>We're sorry, but our website is not optimized for mobile devices. For the best experience, please visit us on a desktop or laptop computer.</h4>
        </div>
      </div>
    </>
  )
}

export default MobileRestricationComponent;
